"use strict";var e=require("react"),t=require("@swiggy-private/dls-web-core/dist/components/Text"),i=require("@swiggy-private/dls-web-icons/dist/GenericIconWeb"),a=require("./helpers-BbN4B1C2.js"),r=require("@swiggy-private/dls-web-food-icons/dist/web/nonveg/NonVeg12"),n=require("@swiggy-private/dls-web-food-icons/dist/web/veg/Veg12"),l=require("@swiggy-private/dls-web-icons/dist/web/generic/chevronDown/12"),o=require("styled-components"),s=require("./_tslib-DHCWbqcQ.js"),d=require("@swiggy-private/js-utils");function u(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var c=u(e),m=u(r),p=u(n),g=u(l),f=u(o);const x=f.default.div`
    display: inline;
`,v=f.default.div`
    display: flex;
    align-items: start;
    margin-bottom: -${e=>e.theme.spacing.xxxSmall};
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    max-height: 3rem;
    overflow: hidden;
    word-break: break-word;
    position: relative;
`,w=f.default(i.GenericIcon)(({theme:e})=>({display:"inline-block",width:"fit-content",height:"fit-content",margin:`2px ${e.spacing.xxSmall} 0px 0px`,verticalAlign:"middle"})),b=f.default(t.Text)`
    margin-top: ${e=>e.theme.spacing.xxxSmall};
`,h=f.default(e=>{var{as:t}=e,i=s.__rest(e,["as"]);return c.default.createElement(t,Object.assign({},i,{"aria-hidden":"true"}),i.children," ")})`
    display: flex;
    margin-top: ${e=>e.theme.spacing.xxxSmall};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`,y=f.default(t.Text)`
    text-overflow: ellipsis;
    overflow: hidden;
    margin-right: 4px;
`,E=f.default.button`
    background: transparent;
    border: none;
    outline: none;
    padding: 0;
    text-align: left;
    appearance: none;
    display: flex;
    align-items: center;
    margin-top: ${e=>e.theme.spacing.xxxSmall};
`;var _=e.memo(function(r){const n=e.useMemo(()=>a.getAddonVariantString(r.addons,r.variants.variantGroups),[r.addons,r.variants.variantGroups]),l=e.useMemo(()=>1===r.vegType,[r.vegType]);return c.default.createElement(x,null,c.default.createElement(v,null,c.default.createElement(w,{Icon:l?p.default:m.default}),c.default.createElement(t.Text,{variant:"V2.body2.neutral.medium",color:"text_High_Emphasis",maxLines:2},r.name)),r.subText&&c.default.createElement(t.Text,{variant:"V2.body3.neutral.regular",color:"text_Low_Emphasis"},r.subText),r.isFreebie&&c.default.createElement(b,{variant:"V2.body3.neutral.regular",color:"text_Low_Emphasis"},"1 Free Delight for you"),!d.isEmpty(n)&&c.default.createElement(h,{as:"div"},c.default.createElement(y,{variant:"V2.body3.neutral.regular",color:"text_Low_Emphasis",onClick:r.onCustomise},n.length>0?n:"Customize"),!r.isGroupOrderFlow&&r.isCustomisable&&c.default.createElement(E,{onClick:r.onCustomise},c.default.createElement(i.GenericIcon,{Icon:g.default,fillColor:"text_Low_Emphasis"}))))});exports.ItemInfo=_,exports.UNAVAILABLE="Unavailable";
//# sourceMappingURL=ItemInfo-BhGqaajn.js.map
